import { render, staticRenderFns } from "./FormSlider.vue?vue&type=template&id=53fa5540&scoped=true&"
import script from "./FormSlider.vue?vue&type=script&lang=js&"
export * from "./FormSlider.vue?vue&type=script&lang=js&"
import style0 from "./FormSlider.vue?vue&type=style&index=0&id=53fa5540&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa5540",
  null
  
)

export default component.exports